(function () {
  angular.module("akitabox.ui.dialogs.assign.assign", [
    "akitabox.core.services.flag",
    "akitabox.core.services.workOrder",
    "akitabox.core.toast",
    "akitabox.ui.components.multipleAssigneeInput",
  ]);
})();
